import { Component, OnInit } from '@angular/core';
import {ModalExtended} from 'ngx-dynamic-modal';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {HlrContextService} from '../../services/hlr-context.service';
import {AlertaService} from '../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-edit-hlr-context',
  templateUrl: './edit-hlr-context.component.html',
  styleUrls: ['./edit-hlr-context.component.scss']
})
export class EditHlrContextComponent extends ModalExtended implements OnInit {

    data: Object;
    formData: FormGroup;
    submitted: boolean = false;
    enabled: boolean = false;

    constructor(private fb: FormBuilder, private hrlConfigHandler: HlrContextService, private alertHandler: AlertaService) {
        super();
        this.formData = this.fb.group({
            'name' : new FormControl('', Validators.required),
            'loc_duration' : new FormControl('', Validators.required),
            'caller_id' : new FormControl('', Validators.required),
            'loc_label' : new FormControl('', Validators.required),
            'caller_id_label' : new FormControl('', Validators.required),
            'active' : new FormControl('0'),
            'description' : new FormControl(),
        });
    }

    onExit(): void{
        this.applyCallback(true);
        this.close();
    }

    createContext(): void {

        if(!this.formData.valid){
            this.submitted = true;
            return;
        }

        this.enabled = true;
        this.hrlConfigHandler.createContext(this.formData.value).subscribe(
            (result) => {
                this.alertHandler.addAlert('success', 'Context with name ' + result.data['name'] + ' has been created successfully');
                this.enabled = false;
            }
        )
    }

    updateContext(): void {

        if(!this.formData.valid){
            this.submitted = true;
            return;
        }

        this.enabled = true;
        this.hrlConfigHandler.updateContext(this.formData.value, this.data['object']['pk']).subscribe(
            (result) => {
                this.alertHandler.addAlert('success', 'Context with name ' + result.data['name'] + ' has been updated successfully');
                this.enabled = false;
            }
        )
    }

    ngOnInit() {
        if(this.data.hasOwnProperty('object')){
            this.formData.controls['name'].setValue(this.data['object']['name']);
            this.formData.controls['loc_duration'].setValue(this.data['object']['loc_duration']);
            this.formData.controls['caller_id'].setValue(this.data['object']['caller_id']);
            this.formData.controls['loc_label'].setValue(this.data['object']['loc_label']);
            this.formData.controls['caller_id_label'].setValue(this.data['object']['caller_id_label']);
            this.formData.controls['active'].setValue(this.data['object']['active']);
            this.formData.controls['description'].setValue(this.data['object']['description']);
        }
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/hlr/modals/edit-hlr-context/edit-hlr-context.component.ts